/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var GLOBAL_FILTER_CLASS = '*';
    MoyaComponents.register('site.filter', function (el) {
        var resultsContainer = el.dataset.filterContainer ? document.querySelector(el.dataset.filterContainer) : el.querySelector('.filter-container');
        var toggles = Array.from(el.querySelectorAll('[data-filter-class]')).map(function (el) {
            return FilterToggle.create(el);
        });
        if (!toggles) {
            console.debug('Missing filter toggles');
        }
        if (!resultsContainer) {
            console.debug('Missing filter container');
        }
        var results = Array.from(resultsContainer.children).map(function (result) {
            return FilterResult.create(result);
        });
        if (!results) {
            console.debug('Missing filter results');
        }
        var config = {
            el: el,
            resultsContainer: resultsContainer,
            results: results,
            toggles: toggles,
            transitionName: el.dataset.transition,
        };
        Filter.create(config).run();
    });
    var Filter = /** @class */ (function () {
        function Filter(config) {
            this.el = config.el;
            this.resultsContainer = config.resultsContainer;
            this.results = config.results;
            this.toggles = config.toggles;
            this.transitionName = config.transitionName;
        }
        Filter.create = function (config) {
            return new Filter(config);
        };
        Filter.prototype.run = function () {
            this.addInitialClasses();
            this.delegateEvents();
            if (this.toggleFromQueryParam()) {
                return;
            }
            this.setGlobalFilterActive();
            this.removeInitClass();
        };
        Filter.prototype.setGlobalFilterActive = function () {
            var globalToggle = this.getGlobalFilterToggle();
            if (globalToggle) {
                globalToggle.markActive();
            }
        };
        Filter.prototype.removeInitClass = function () {
            this.resultsContainer.classList.remove('isFiltering');
        };
        Filter.prototype.addInitialClasses = function () {
            this.resultsContainer.classList.add('filter-container');
            if (this.transitionName) {
                this.resultsContainer.classList.add(this.transitionName);
            }
        };
        Filter.prototype.delegateEvents = function () {
            var _this = this;
            util.delegate(this.el, 'click', '[data-filter-class]', function (e) {
                e.preventDefault();
                var filterToggle = _this.getToggleByFilterClass(e.delegateTarget.dataset.filterClass);
                if (!filterToggle) {
                    return;
                }
                _this.clickToggle(filterToggle);
            });
        };
        Filter.prototype.clickToggle = function (toggle) {
            var globalToggle = this.getGlobalFilterToggle();
            if (toggle.isActive()) {
                if (globalToggle) {
                    if (globalToggle == toggle) {
                        return;
                    }
                    if (globalToggle.getElement().parentElement == toggle.getElement().parentElement) {
                        this.clickToggle(globalToggle);
                        return;
                    }
                }
                toggle.unmarkActive();
            }
            else {
                this.toggles.forEach(function (t) {
                    if (t !== toggle && t.getElement().parentNode == toggle.getElement().parentNode) {
                        t.unmarkActive();
                    }
                });
                toggle.markActive();
            }
            this.filterResults();
            this.updateQuery();
        };
        Filter.prototype.getActiveFilterClasses = function (separator) {
            return this.toggles.filter(function (toggle) {
                return toggle.isActive() && !toggle.isGlobal();
            }).map(function (toggle) {
                return toggle.getFilterClass();
            }).join(separator);
        };
        Filter.prototype.filterResults = function () {
            var _this = this;
            var classes = this.getActiveFilterClasses('.');
            this.resultsContainer.classList.add('isFiltering');
            var counter = 0;
            setTimeout(function () {
                _this.results.forEach(function (result) {
                    var show = !classes || result.getElement().matches('.' + classes);
                    if (show) {
                        result.show();
                        counter++;
                    }
                    else {
                        result.hide();
                    }
                });
                _this.resultsContainer.classList.remove('isFiltering');
                if (counter) {
                    _this.resultsContainer.classList.remove('noResults');
                }
                else {
                    _this.resultsContainer.classList.add('noResults');
                }
            }, 200);
        };
        Filter.prototype.getToggleByFilterClass = function (filterClass) {
            return this.toggles.filter(function (toggle) {
                return toggle.getFilterClass() === filterClass;
            }).shift();
        };
        Filter.prototype.getGlobalFilterToggle = function () {
            return this.getToggleByFilterClass(GLOBAL_FILTER_CLASS);
        };
        Filter.prototype.toggleFromQueryParam = function () {
            var _this = this;
            var hash = window.location.hash.slice(1).replace('%7C', '|');
            if (!hash) {
                return false;
            }
            hash.split('|').forEach(function (filterClass) {
                var t = _this.getToggleByFilterClass(filterClass);
                t.markActive();
            });
            this.filterResults();
            return true;
        };
        Filter.prototype.updateQuery = function () {
            var classes = this.getActiveFilterClasses('|');
            if (!classes) {
                window.history.replaceState('', '', window.location.pathname);
                return;
            }
            var filterQueryParam = '#' + classes;
            window.history.replaceState('', '', filterQueryParam);
        };
        return Filter;
    }());
    var FilterToggle = /** @class */ (function () {
        function FilterToggle(el) {
            this.el = el;
            this.filterClass = el.dataset.filterClass;
        }
        FilterToggle.create = function (el) {
            return new FilterToggle(el);
        };
        FilterToggle.prototype.getElement = function () {
            return this.el;
        };
        FilterToggle.prototype.getFilterClass = function () {
            return this.filterClass;
        };
        FilterToggle.prototype.isActive = function () {
            return this.active;
        };
        FilterToggle.prototype.isGlobal = function () {
            return this.filterClass === GLOBAL_FILTER_CLASS;
        };
        FilterToggle.prototype.markActive = function () {
            this.el.classList.add('active');
            this.active = true;
        };
        FilterToggle.prototype.unmarkActive = function () {
            this.el.classList.remove('active');
            this.active = false;
        };
        return FilterToggle;
    }());
    var FilterResult = /** @class */ (function () {
        function FilterResult(el) {
            this.el = el;
        }
        FilterResult.create = function (el) {
            return new FilterResult(el);
        };
        FilterResult.prototype.getElement = function () {
            return this.el;
        };
        FilterResult.prototype.show = function () {
            this.el.style.removeProperty('display');
        };
        FilterResult.prototype.hide = function () {
            this.el.style.display = 'none';
        };
        return FilterResult;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
